import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './404.scss';

const NotFoundPage = () => {
  return (
    <>
      <Helmet>
        <meta name="prerender-status-code" content="404" />
        <title>404 — Page Not Found</title>
      </Helmet>

      <div className="animationContainer">
        <div className="not-found-text">
          <h2>Oops! Page not found.</h2>
          <p>Looks like you're lost. Let's get you back home!</p>
          <Link to="/" className="home-link">Go to Home</Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
